module.exports = __webpack_public_path__ + "img/logo5A.901a43fe.png";